import { create } from 'zustand';
import { resetFocusDonorSection } from './common';

interface useDonorNavigationStore {
    step: number;
    nextStep: () => void;
}

export const useDonorNavigation = create<useDonorNavigationStore>(set => {
    return {
        step: 1,
        nextStep: (): void => {
            set(state => {
                return { step: state.step + 1 };
            });

            resetFocusDonorSection();
        },
    };
});
